import React from "react";
import "./footer.css";
import {
  RiFacebookBoxLine,
  RiInstagramLine,
  RiLinkedinBoxLine,
  RiTwitterFill,
} from "react-icons/ri";
import { SiTiktok } from "react-icons/si";
import { FiPhone, FiMail } from "react-icons/fi";
import { utils } from "../../utils/Utils.jsx";

function Footer(props) {
  return (
    <React.Fragment>
      <div className="layout-footer">
        <div className="top-row">
          <div className="logo-div">
            <a
              href="https://www.blox.global/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className="logo"
                src="https://blox-brand-assets.s3.amazonaws.com/logos/blox-lockup-green.png"
                alt="Company Logo"
              />
            </a>
            <a
              href="https://www.blox.global/"
              target="_blank"
              rel="noopener noreferrer"
              className="title"
            >
              {process.env.REACT_APP_COMPANY_NAME}
            </a>
          </div>
          <div className="go-to">
            <div className="title">{props.localizedText["go-to"]}</div>
            <div className="links-div">
              <a href="https://bloxcross.com/#">
                {props.localizedText["home"]}
              </a>
              <a href="https://bloxcross.com/#benefits">
                {props.localizedText["benefits"]}
              </a>
              <a href="https://bloxcross.com/#about_us">
                {props.localizedText["about-us"]}
              </a>
              <a href="https://bloxcross.com/#contact">
                {props.localizedText["contact"]}
              </a>
            </div>
          </div>
          <div className="contact-us">
            <div className="title">
              {props.localizedText["contact-us"] || "Contact us"}
            </div>
            <div className="contact-details">
              <div className="contact-item">
                <FiPhone className="contact-icon" />

                <span className="contact-value">
                  {process.env.REACT_APP_CONTACT_PHONE}
                </span>
              </div>
              <div className="contact-item">
                <FiMail className="contact-icon" />
                <span className="contact-value">
                  {process.env.REACT_APP_CONTACT_EMAIL}
                </span>
              </div>
            </div>
          </div>
          <div className="terms">
            <a className="link" href={"/terms/" + props.region} target="_blank">
              {props.localizedText["terms-and-conditions"]}
            </a>
            <a
              className="link"
              href="https://bloxcross.com/privacy_policy_en.pdf"
            >
              {props.localizedText["privacy-policy"]}
            </a>
          </div>
        </div>
        <div className="bottom-row">
          {props.localizedText["footer-bottom-top-text"] +
            process.env.REACT_APP_COMPANY_NAME +
            props.localizedText["footer-bottom-middle-text"] +
            process.env.REACT_APP_COMPANY_WEBSITE +
            props.localizedText["footer-bottom-bottom-text"]}
        </div>
      </div>
    </React.Fragment>
  );
}

export default Footer;
